import { Heading, Text, Flex, AspectRatio, Skeleton } from '@chakra-ui/react'
import React, { useState } from 'react'
import PageWrapper from '../Common/PageWrapper'

const ContactPage: React.FC = () => {
  const [loading, setLoading] = useState(true)

  return (
    <PageWrapper>
      <Heading mb={12}>Yhteystiedot</Heading>
      <Flex maxW='1200px' direction='column' alignItems='center'>
        <Text maxW='800px' mb={4} pl={4} pr={4}>
          Seppo Ruotsala puh 040-1395004. Sähköposti: seppo.ruotsala@gmail.com
        </Text>
        {loading && (
          <AspectRatio w={{ base: '100vw', md: '800px' }} ratio={4 / 3}>
            <Skeleton />
          </AspectRatio>
        )}
        <AspectRatio w={{ base: '100vw', md: '800px' }} ratio={4 / 3}>
          <iframe
            title='Yhteystiedot Kauhavan Veteraanitalo'
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1805.3278258352368!2d23.021368199999998!3d63.096851300000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4687aeee7cea304d%3A0xfc27abbef8817feb!2sMuseotie%2016%2C%2062200%20Kauhava!5e0!3m2!1sfi!2sfi!4v1666520020001!5m2!1sfi!2sfi'
            // width='600'
            // height='450'
            // style='border:0;'
            onLoad={() => setLoading(false)}
            style={{ border: 'none', display: loading ? 'none' : 'block' }}
            allowFullScreen
            referrerPolicy='no-referrer-when-downgrade'
          />
        </AspectRatio>
      </Flex>
    </PageWrapper>
  )
}
export default ContactPage
